import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { AppCommonModule } from "@common/common.module";

import { CookiePolicyComponent } from "./cookie-policy/cookie-policy.component";
import { DisclaimerComponent } from "./disclaimer/disclaimer.component";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { RiskFactorsComponent } from "./risk-factors/risk-factors.component";
import { StatuoryComponent } from "./statuory/statuory.component";
import { TermsUseComponent } from "./terms-use/terms-use.component";
import { ExecutiveRemunerationComponent } from "./statuory/executive-remuneration/executive-remuneration.component";
import { RemunerationDialogComponent } from './statuory/remuneration-dialog/remuneration-dialog.component';


@NgModule({
  declarations: [
    RiskFactorsComponent,
    DisclaimerComponent,
    PrivacyPolicyComponent,
    CookiePolicyComponent,
    StatuoryComponent,
    TermsUseComponent,
    ExecutiveRemunerationComponent,
    RemunerationDialogComponent,
  ],
  imports: [ AppCommonModule],
  exports: [
    RiskFactorsComponent,
    DisclaimerComponent,
    PrivacyPolicyComponent,
    CookiePolicyComponent,
    StatuoryComponent,
    TermsUseComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class KeyPolicyModule {}
